import { styled } from "@mui/styles";

export const GreenPlus = styled("span")({
  color: "#056645",
});

export const RedMinus = styled("span")({
  color: "#790202",
});

interface BalanceOverviewChangeProps {
  change: string;
  dollarChange: string;
  unformattedChange: number;
}

const BalanceOverviewChange = (props: BalanceOverviewChangeProps) => {
  const { change, dollarChange, unformattedChange } = props;

  const color = unformattedChange >= 0 ? "#056645" : "#790202";
  const backgroundColor = unformattedChange >= 0 ? "#F7FFFC" : "#FFFBFB";

  if (unformattedChange >= 0) {
    return (
      <span
        style={{
          backgroundColor,
        }}
        translate="no">
        <GreenPlus>+{change}</GreenPlus>(<GreenPlus>+{dollarChange}</GreenPlus>)
      </span>
    );
  }

  const removedMinusChange = change.replace("-", "");
  const removedMinusDollarChange = dollarChange.replace("-", "");
  return (
    <span
      style={{
        color,
        backgroundColor,
        padding: "2px 6px",
        borderRadius: "4px",
      }}
      translate="no">
      <RedMinus>-{removedMinusChange}</RedMinus>(<RedMinus>-{removedMinusDollarChange}</RedMinus>)
    </span>
  );
};

export default BalanceOverviewChange;
